'use strict';

/*
    DatedEventList
    Display a list of events (objects with an associated date) in a chronological list headed by date headings.
    Parameters:
        events [array] - list of objects to display chronologically
        datePropertyName [string] - name of the property in each event object that is a date to sort on
        ignoreTimezone [boolean] - account for timezone (false) or not
        sortOrder [string] - Additional sorting of data based on datePropertyName: 'chronological' | 'reverseChronological' | 'none';
        getEventListItemHtml [function] - function that takes an empty HTMLElement and event object arguments and returns a populated HTMLElement
    Methods (see methods for additional usage):
        update(events)
*/

function DatedEventList() {
  this.extends = [_AccountController];
  this.declaredClass = null;
  this.node = null;
  this.id = null;

  this.events = [];
  this.datePropertyName = '';
  this.ignoreTimezone = true;
  this.sortOrder = 'reverseChronological';
  this.daySubHeading = false;
  this.daySubHeadingClassName = '';
  this.getEventListItemHtml = function () {};

  this.presenter = $('[data-mogo-ui=Portal]').mogo().presenter;

  this.init = function () {};

  this.initAllReady = function () {
    this._show();
  };

  this.destroy = function () {
    this._super();
  };

  /*
      Update the list with a new set of events.
      Arguments:
        events [array]:
          Array of new events to update the list with.
  */
  this.update = function (events) {
    this.events = events;
    this.node.innerHTML = '';
    this._show();
  };

  this._show = function () {
    this.node.appendChild(this._getHtml());
    this.node.style.display = 'block';
  };

  this._getHtml = function () {
    var _this = this;

    var eventHistoryListElement = void 0;
    var eventsByDateData = void 0;
    var eventDays = void 0;
    var eventDaysKeys = void 0;
    var numDays = void 0;
    var daySubHeading = void 0;
    var dayIndex = void 0;
    var day = void 0;
    var dayHeading = void 0;
    var dayList = void 0;
    var numAlerts = void 0;
    var event = void 0;
    var dayItem = void 0;

    eventHistoryListElement = document.createElement('div');
    eventHistoryListElement.className = 'dated-event-list';

    if (this.events.length) {
      eventsByDateData = this._getEventsByDate();
      eventDays = eventsByDateData[0];
      eventDaysKeys = eventsByDateData[1];

      if (this.sortOrder !== 'none') {
        eventDaysKeys.sort(function (a, b) {
          return _this.sortOrder === 'reverseChronological' ? b - a : a - b;
        });
      }

      numDays = eventDaysKeys.length;
      for (dayIndex = 0; dayIndex < numDays; dayIndex++) {
        day = eventDays[eventDaysKeys[dayIndex]];

        // sort day's events by time
        day.sort(function (a, b) {
          return new Date(b[_this.datePropertyName]) - new Date(a[_this.datePropertyName]);
        });

        // day heading
        dayHeading = document.createElement('h3');
        dayHeading.className = 'dated-event-list__date';
        dayHeading.appendChild(document.createTextNode(day.name));
        eventHistoryListElement.appendChild(dayHeading);

        // day subheading
        if (this.daySubHeading) {
          daySubHeading = document.createElement('span');
          daySubHeading.className = 'dated-event-list__date-subheading ' + this.daySubHeadingClassName;
          daySubHeading.dataset.date = moment(eventDaysKeys[dayIndex]).format('YYYY-MM-DD');
          dayHeading.appendChild(daySubHeading);
        }

        // list of events for the day
        dayList = document.createElement('ul');
        dayList.className = 'dated-event-list__items';

        numAlerts = day.length;
        for (var eventIndex = 0; eventIndex < numAlerts; eventIndex++) {
          event = day[eventIndex];

          dayItem = document.createElement('li');
          dayItem.className = 'dated-event-list__item';

          dayList.appendChild(this.getEventListItemHtml(dayItem, event));
        }
        eventHistoryListElement.appendChild(dayList);
      }
    }
    return eventHistoryListElement;
  };

  this._getEventsByDate = function () {
    var eventDays = void 0;
    var eventDaysKeys = void 0;
    var numEvents = void 0;
    var index = void 0;
    var event = void 0;
    var timezoneOffset = void 0;
    var eventDateParts = void 0;
    var eventDate = void 0;
    var key = void 0;
    var today = void 0;
    var yesterday = void 0;

    eventDays = [];
    eventDaysKeys = [];
    if (this.events && this.events.length) {
      numEvents = this.events.length;
      for (index = 0; index < numEvents; index++) {
        event = this.events[index];

        timezoneOffset = this.getTimezoneOffset();
        if (!timezoneOffset) {
          timezoneOffset = 0;
        }

        // extract date info from event
        if (this.ignoreTimezone) {
          eventDateParts = event[this.datePropertyName].split('-');
          eventDate = new Date(eventDateParts[0], eventDateParts[1] - 1, parseInt(eventDateParts[2]));
        } else {
          eventDate = Date.getOtherTimezoneTime(new Date(event[this.datePropertyName]), timezoneOffset);
        }
        event.year = eventDate.getFullYear();
        event.month = eventDate.getMonth() + 1;
        event.day = eventDate.getDate();

        // build key from date
        key = '' + event.year + (event.month < 10 ? '0' : '') + event.month + (event.day < 10 ? '0' : '') + event.day;

        // if this is a new date in the list, create the title for the date
        if (!eventDays[key]) {
          eventDaysKeys.push(key);
          eventDays[key] = [];
          eventDays[key].name = Date.toFormattedString(eventDate, 'mmm dd, yyyy');

          // today's events
          today = Date.getOtherTimezoneTime(new Date(), timezoneOffset);
          if (event.year === today.getFullYear() && event.month === today.getMonth() + 1 && event.day === today.getDate()) {
            eventDays[key].name = 'Today';
          }

          // yesterday's events
          if (this.ignoreTimezone) {
            yesterday = new Date(new Date().setDate(today.getDate() - 1));
          } else {
            yesterday = Date.getOtherTimezoneTime(new Date(new Date().setDate(today.getDate() - 1)), timezoneOffset);
          }
          if (event.year === yesterday.getFullYear() && event.month === yesterday.getMonth() + 1 && event.day === yesterday.getDate()) {
            eventDays[key].name = 'Yesterday';
          }
        }

        // push this event into the list of events for the date
        eventDays[key].push(event);
      }
    }
    return [eventDays, eventDaysKeys];
  };
}